<div *ngIf="passwordReseted" class="auth-container" [ngClass]="{ mobile: isMobile$ | async }">
  <mat-card>
    <h1 class="mat-headline-3">{{ 'WM_TECH.AUTH.RESET_PASSWORD.TITLE' | translate }}</h1>
    <h2 class="mat-subtitle-2">
      {{ 'WM_TECH.AUTH.RESET_PASSWORD.SUBTITLE' | translate }}
    </h2>

    <mat-card-content>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="passwordConfirm()">
        <mat-form-field appearance="outline" class="wm-input">
          <input formControlName="password" [placeholder]="'WM_TECH_POOL.FORMS.NEW_PASSWORD' | translate" matInput [type]="hidePassword ? 'password' : 'text'" required />
          <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" class="wm-input">
          <input formControlName="confirmPassword" [placeholder]="'WM_TECH_POOL.FORMS.NEW_PASSWORD_CONFIRM' | translate" matInput [type]="hideConfirmPassword ? 'password' : 'text'" required />
          <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword">
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <button mat-raised-button color="tech-button-bg-primary" type="submit" class="submit-button" [disabled]="resetPasswordForm.invalid">Reset Password</button>
      </form>

      <div class="auth-links">
        <p>
          Remembered your password?
          <a routerLink="/auth/sign-in">{{ 'WM_TECH.AUTH.RESET_PASSWORD.SIGNIN' | translate }}</a>
        </p>
      </div>
    </mat-card-content>
  </mat-card>
</div>
